import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PreguntasFrecuentesComponent } from './preguntas-frecuentes.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { FlexLayoutModule } from '@angular/flex-layout';

const routes = [
  {
      path     : 'medicamentos/preguntas-frecuentes',
      component: PreguntasFrecuentesComponent
  }
];

@NgModule({
  declarations: [
    PreguntasFrecuentesComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatExpansionModule,
    FlexLayoutModule 
    
  ]
})
export class PreguntasFrecuentesModule { }
